import { CertificateType, DestinationMarket } from "@tc/graphql-server"

/**
 * Map a country code to a specific market. The market depends on the
 *  certificate type.
 *
 * @param countryCode - ISO 2 alpha country code
 */
export const country_code_to_market = (
  certificateType: CertificateType,
  countryCode: string,
): DestinationMarket => {
  switch (certificateType) {
    case CertificateType.ExportEligibilityStatement:
      return country_code_to_wine_market(countryCode)
    default:
      return country_code_to_other_market(countryCode)
  }
}

export const country_code_to_other_market = (
  country_code: string,
): DestinationMarket => {
  switch (country_code) {
    case "GB":
      return DestinationMarket.GreatBritain
    case "JP":
      return DestinationMarket.Japan
    case "AU":
      return DestinationMarket.Australia
    case "CN":
      return DestinationMarket.China
    case "SG":
      return DestinationMarket.Singapore
    case "TW":
      return DestinationMarket.Taiwan
    case "BR":
      return DestinationMarket.Brazil
    case "UA":
      return DestinationMarket.Ukraine

    case "EU":
    case "AT":
    case "BE":
    case "BG":
    case "HR":
    case "CY":
    case "CZ":
    case "DK":
    case "EE":
    case "FI":
    case "FR":
    case "DE":
    case "GR":
    case "HU":
    case "IE":
    case "IT":
    case "LV":
    case "LT":
    case "LU":
    case "MT":
    case "PL":
    case "PT":
    case "RE":
    case "RO":
    case "SK":
    case "SI":
    case "ES":
    case "SE":
    case "NL":
      return DestinationMarket.Eu

    default:
      return DestinationMarket.NotApplicable
  }
}

const country_code_to_wine_market = (
  country_code: string,
): DestinationMarket => {
  switch (country_code) {
    // EU country codes (ISO 3166), Greece: EL, Eurostat
    case "EU":
    case "AT":
    case "BE":
    case "BG":
    case "HR":
    case "CY":
    case "CZ":
    case "DK":
    case "EE":
    case "FI":
    case "FR":
    case "DE":
    case "GR":
    case "EL":
    case "HU":
    case "IE":
    case "IT":
    case "LV":
    case "LT":
    case "LU":
    case "MT":
    case "NL":
    case "PL":
    case "PT":
    case "RO":
    case "SK":
    case "SI":
    case "ES":
    case "SE":
      return DestinationMarket.Eu

    case "GB":
      return DestinationMarket.GreatBritain

    case "BR":
      return DestinationMarket.Brazil

    default:
      return DestinationMarket.NotApplicable
  }
}
